import { render, staticRenderFns } from "./MyCouponDetail.vue?vue&type=template&id=050741af&scoped=true"
import script from "./MyCouponDetail.vue?vue&type=script&lang=js"
export * from "./MyCouponDetail.vue?vue&type=script&lang=js"
import style0 from "./MyCouponDetail.vue?vue&type=style&index=0&id=050741af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050741af",
  null
  
)

export default component.exports